export const sessionStorageAdapter = {
  save: (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value));
  },

  load: (key, defaultValue = null) => {
    const value = sessionStorage.getItem(key);

    if (value === null) {
      return defaultValue;
    }

    try {
      return JSON.parse(value);
    } catch {
      return defaultValue;
    }
  },

  remove: (key) => {
    sessionStorage.removeItem(key);
  },
};